import { forwardRef, ButtonHTMLAttributes } from "react";
import Tooltip from "../core/Tooltip";
import FeatureDiscoveryTooltip, { FeatureDiscoveryTooltipProps } from "../FeatureDiscoveryTooltip";

type ToolbarButtonFeatureDiscoveryTooltipProps = Omit<
  FeatureDiscoveryTooltipProps,
  'children' | 'isOpen'
>;

type ToolbarButtonProps = {
  id?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
  DiscoveryTooltipProps?: ToolbarButtonFeatureDiscoveryTooltipProps;
  tooltipContent?: string;
  title?: string;
  isActive?: boolean;
} & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'onClick' | 'disabled' | 'title' | 'id'>;

const ToolbarButton = forwardRef<HTMLButtonElement, ToolbarButtonProps>(({
  id,
  onClick,
  icon,
  children,
  className,
  isLoading = false,
  disabled = false,
  DiscoveryTooltipProps,
  tooltipContent,
  title = '',
  isActive = false,
  ...rest
}, ref) => {

  const button = (
    <button
      ref={ref}
      title={title}
      {...(id && { id })}
      className={`${
        className ? `${className} ` : ""
      }cursor-pointer justify-center items-center disabled:opacity-50 flex px-3 py-[6px] h-[36px] rounded-[4px] border-[1px] leading-6 text-[14px] border-border ${
        isActive
          ? "bg-gray-100 text-primary"
          : "text-gray-primary"
      }`}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {isLoading && (
        <div className="w-4 h-4 border-2  border-solid  border-t-blue-500  border-primary rounded-full animate-spin"></div>
      )}
      {!isLoading && icon && (
        <div className={`${children ? "mr-1" : ""}`}>{icon}</div>
      )}
      {!isLoading && children}
    </button>
  );

  if (DiscoveryTooltipProps) {
    return (
      <FeatureDiscoveryTooltip
        {...DiscoveryTooltipProps}
        isOpen
      >
        {button}
      </FeatureDiscoveryTooltip>
    );
  }
  if (tooltipContent) {
    return (
      <Tooltip content={tooltipContent}>
        {button}
      </Tooltip>
    );
  }
  return button;
});

ToolbarButton.displayName = "ToolbarButton";

export default ToolbarButton;
